import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: 'progress-bar.html'
})
export class ProgressBarComponent {

  @Input('percentage') public percentage: number;
  @Input('configColor') public configColor: any;

  public currentPercent: number = 0;

  constructor() { }

  public get calculateColor() {
    let color = 'none';
    if (this.currentPercent > 0) {
      if (this.currentPercent <= 5) color = 'gray';
      if (this.currentPercent > 5 && this.currentPercent <= 10) color = '#A4A4A4';
      if (this.currentPercent > 10 && this.currentPercent <= 15) color = '#FE2E64';
      if (this.currentPercent > 15 && this.currentPercent <= 20) color = '#FE2E9A';
      if (this.currentPercent > 20 && this.currentPercent <= 25) color = '#FE2EC8';
      if (this.currentPercent > 25 && this.currentPercent <= 30) color = '#FE2EF7';
      if (this.currentPercent > 30 && this.currentPercent <= 35) color = '#CC2EFA';
      if (this.currentPercent > 35 && this.currentPercent <= 40) color = '#9A2EFE';
      if (this.currentPercent > 40 && this.currentPercent <= 45) color = '#642EFE';
      if (this.currentPercent > 45 && this.currentPercent <= 50) color = '#2E2EFE';
      if (this.currentPercent > 50 && this.currentPercent <= 55) color = '#2E64FE';
      if (this.currentPercent > 55 && this.currentPercent <= 60) color = '#2E9AFE';
      if (this.currentPercent > 60 && this.currentPercent <= 65) color = '#2ECCFA';
      if (this.currentPercent > 65 && this.currentPercent <= 70) color = '#2EFEF7';
      if (this.currentPercent > 70 && this.currentPercent <= 75) color = '#2EFEC8';
      if (this.currentPercent > 75 && this.currentPercent <= 80) color = '#2EFE9A';
      if (this.currentPercent > 80 && this.currentPercent <= 85) color = '#2EFE64';
      if (this.currentPercent > 85 && this.currentPercent <= 90) color = '#2EFE2E';
      if (this.currentPercent > 90 && this.currentPercent <= 95) color = '#9AFE2E';
      if (this.currentPercent > 95) color = '#0B6138';
    }
    return color;
  }
}



// WEBPACK FOOTER //
// ./src/components/progress-bar/progress-bar.ts